module.exports = __webpack_public_path__ + "img/787-bf40db.png";